import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchResult, serializeLocalDate } from '@heda/core-util';
import { SearchHttpParams } from '@heda/core-util';
import { MessageLog, MessageLogSearchParams } from 'app/pechkin/messagelog/services/messageLog';

@Injectable()
export class MessageLogService {
  protected baseUrl = `${environment.pechkinApi}/message-logs`;

  constructor(private http: HttpClient) {}

  public getMessageLog(id: string): Observable<MessageLog> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get(url).pipe(map((resp) => resp as MessageLog));
  }

  public query(params: MessageLogSearchParams): Observable<SearchResult<MessageLog>> {
    params.dateFrom = params.dateFrom ? serializeLocalDate(params.dateFrom) : null;
    params.dateTo = params.dateTo ? serializeLocalDate(params.dateTo) : null;
    const p: any = Object.assign({}, params);
    return this.http
      .get(`${this.baseUrl}`, { params: SearchHttpParams.build(p) })
      .pipe(map((resp) => resp as SearchResult<MessageLog>));
  }

  public resend(id: string): Observable<any> {
    const url = `${this.baseUrl}/${id}/resend`;
    return this.http.post(url, {}).pipe(map((resp) => resp as MessageLog));
  }
}
